import {
  type InvalidResult,
  ValidationError,
} from '@/backend/errors/ValidationError';

/**
 * Finds the error which is hopefully the most relevant
 *
 * @returns the deepest error which does not have siblings
 *
 * @example
 *
 * oneOfValidator(stringValidator, numberValidator)(true) -> "The value did not match any of the expected validations"
 *
 * @example
 *
 * stringValidator(true) -> "The value is not a string"
 *
 * @example
 *
 * objectValidator({ name: stringValidator, age: numberValidator })({ name: "joe" }) -> "age: The value is not a number"
 *
 */
export function findRelevantProblem(error: InvalidResult): string {
  if (!error.inner || error.inner.length !== 1) {
    const prefix = error.path.length ? error.path.join('.') + ': ' : '';

    return prefix + error.description;
  }

  return findRelevantProblem(error.inner[0]);
}
